import { useContext } from 'preact/hooks';
import { ApplicationContext } from 'services/use-application-setup';
import { useClickOutside } from '@uw/common-components';

export const useClickOutsideElement = (ref, callback) => {
  const { isOpen } = useContext(ApplicationContext);

  useClickOutside(ref, callback, isOpen);
};
